import React, { useState } from 'react';
import { User } from 'interfaces/user.interface';
import { EventCommitment } from 'interfaces/types.interface';
import EngagementStatusIcons from './engagementStatusIcon.component';

interface EngagementCardProps {
  engagement: EventCommitment;
  engagementIndex: number;
  dayStart?: Date;
  canDrag?: boolean;
  cursor?: string;
  themeHightlighted?: string;
  user?: User;
  isDragging?: boolean;
  isHighlighted?: boolean;
  setIsDragging?: ( dragging: boolean ) => void;
  onEngagementClick?: ( task: EventCommitment ) => void;
  handleDragStart?: (
    e: React.DragEvent<HTMLDivElement>,
    task: EventCommitment,
    dayStartDrag: Date,
    user: User
  ) => void
}

const EngagementLineCard: React.FC<EngagementCardProps> = ( {
  engagement,
  themeHightlighted,
  engagementIndex,
  dayStart,
  canDrag,
  cursor = 'cursor-grab',
  user,
  isDragging,
  isHighlighted = false,
  setIsDragging,
  onEngagementClick,
  handleDragStart,
} ) => {
  const [ isDraggingSelf, setIsDraggingSelf ] = useState( false );

  const onDragStart = ( e: React.DragEvent<HTMLDivElement> ) => {
    setIsDragging?.( true );
    setIsDraggingSelf( true );
    if ( dayStart && user ) {
      handleDragStart?.( e, engagement, dayStart, user );
    }
  };

  const onDragEnd = () => {
    setIsDragging?.( false );
    setIsDraggingSelf( false );
  };

  const handleClick = ( e: React.MouseEvent<HTMLDivElement> ) => {
    e.stopPropagation();
    onEngagementClick?.( engagement );
  };

  const dragOpacityClass = isDragging
    ? isDraggingSelf
      ? 'opacity-0'
      : 'opacity-50'
    : 'opacity-100';

  const archivedStyle = engagement.archived
    ? 'opacity-60 cursor-not-allowed'
    : '';

  let effectiveIsHighlighted = isHighlighted;
  if ( themeHightlighted !== undefined && themeHightlighted !== null ) {
    effectiveIsHighlighted = themeHightlighted === engagement.color;
  }
  const highlightClass = effectiveIsHighlighted ? 'highlighted-engagement-card-flash' : '';

  return (
    <div
      key={engagementIndex}
      className={`${themeHightlighted && ( themeHightlighted == engagement.color ? 'opacity-100' : 'opacity-40' )}
      trans-fast border-2 flex bg-[#fcffcf] flex-col relative dark:bg-dark-bg-light dark:text-white h-fit w-full max-w-[260px] rounded-md shadow-xl ${cursor} ${dragOpacityClass} ${archivedStyle}
      ${isHighlighted ? highlightClass : ''}`}
      onClick={handleClick}
      onDragStart={canDrag ? onDragStart : e => {return e.preventDefault();}}
      onDragEnd={onDragEnd}
      draggable={!!canDrag}
      style={{
        borderColor: engagement.color,
        transition: isHighlighted ? 'none' : 'transform 0.2s ease-in-out',
        zIndex: isHighlighted ? 5 : 1
      } as React.CSSProperties}
    >

      <div className="absolute w-full -top-1 h-2 z-10 flex-center">
        <div
          className="h-4 flex-center bg-white top-2 w-4 rounded-full border-2"
          style={{
            borderColor: engagement.color,
            backgroundColor: engagement.color,
          }}
        />
      </div>

      <div className='flex flex-col h-full overflow--y-scroll'>
        <span className="w-full mt-2.5 px-0.5 text-center text-[18px] z-10 break-words line-clamp-2 leading-[20px]">
          {engagement.eventTitle}
        </span>

        <EngagementStatusIcons lightMode={ true } engagement={engagement} />
      </div>
    </div>
  );
};

export default EngagementLineCard;
